export var PanelName;
(function (PanelName) {
    PanelName["ADD_FORM"] = "addFormPanel";
    PanelName["FORM_MANAGE_FIELDS"] = "manageFieldsPanel";
    PanelName["FORM_SETTINGS"] = "settingsPanel";
    PanelName["NEW_FORM_SETTINGS"] = "formSettingsPanel";
    PanelName["FORM_STYLE"] = "formStylePanel";
    PanelName["FORM_LAYOUT"] = "formLayoutPanel";
    PanelName["FIELD_SETTINGS"] = "fieldSettingsPanel";
    PanelName["SUBMIT_SETTINGS"] = "submitSettingsPanel";
    PanelName["ADD_FIELD"] = "addFieldPanel";
    PanelName["UPGRADE_ALERT"] = "upgradeAlertPanel";
    PanelName["FORM_MANAGE_SUBSCRIBERS"] = "manageSubscribersPanel";
    PanelName["SITE_MEMBERS_SETTINGS"] = "panels.focusPanels.siteMembersSettingsPanel";
    PanelName["CONNECT_FIELD"] = "connectFieldPanel";
    PanelName["RECAPTCHA_HELP"] = "recaptchaHelp";
    PanelName["PUBLISH_SITE_POP_UP"] = "publishSitePop";
    PanelName["PAYMENT_WIZARD"] = "paymentWizardPanel";
    PanelName["DELETE_PAYMENT_ALERT"] = "deletePaymentAlert";
    PanelName["CLOSE_PAYMENT_WIZARD_ALERT"] = "closePaymentWizardAlert";
    PanelName["ADI_EDIT_FORM"] = "adiEditFormPanel";
    PanelName["ADI_EDIT_FIELD"] = "adiEditFieldPanel";
    PanelName["MANAGE_STEPS"] = "manageSteps";
    PanelName["CHANGE_BUTTON_LABEL"] = "changeButtonLabel";
    PanelName["CONTACT_SYNC_PANEL"] = "contactSyncPanel";
    PanelName["WARNING"] = "warning";
})(PanelName || (PanelName = {}));
export var NativePanelName;
(function (NativePanelName) {
    NativePanelName["SETTINGS"] = "settings";
})(NativePanelName || (NativePanelName = {}));
//# sourceMappingURL=panel-names.js.map